import React from 'react';
import { Button } from 'antd';
import { startGoogleLogin } from '../../utils/authUrls';
import './GoogleAuthButton.scss';

const GoogleLogo = () => (
  <svg
    className="google-auth-button__icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="#4285F4"
      d="M23.49 12.27c0-.79-.07-1.54-.2-2.27H12v4.29h6.46c-.28 1.5-1.12 2.77-2.39 3.62v3.01h3.88c2.27-2.09 3.54-5.17 3.54-8.65z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.96-1.07 7.95-2.91l-3.88-3.01c-1.08.72-2.45 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.95H1.26v3.11C3.24 21.32 7.3 24 12 24z"
    />
    <path
      fill="#FBBC05"
      d="M5.27 14.28c-.24-.72-.38-1.49-.38-2.28s.14-1.56.38-2.28V6.61H1.26C.45 8.22 0 10.06 0 12s.45 3.78 1.26 5.39l4.01-3.11z"
    />
    <path
      fill="#EA4335"
      d="M12 4.77c1.76 0 3.34.61 4.59 1.79l3.44-3.44C17.95 1.18 15.24 0 12 0 7.3 0 3.24 2.68 1.26 6.61l4.01 3.11C6.22 6.88 8.87 4.77 12 4.77z"
    />
  </svg>
);

const GoogleAuthButton: React.FC = () => (
  <Button
    block
    htmlType="button"
    className="google-auth-button"
    onClick={startGoogleLogin}
    aria-label="Continue with Google"
  >
    <GoogleLogo />
    <span>Continue with Google</span>
  </Button>
);

export default GoogleAuthButton;
